<template>
	<!-- <f7-page class=""> -->
  <div class="page" id="contactDebtorList">
    <!--bottom-toolbar></bottom-toolbar-->
    <f7-toolbar class="contactListToolbar">
      <f7-link class="streammindContactListButton yellowButton okButtonContactList" @click="goBack">OK</f7-link>
      <f7-link class="streammindContactListButton yellowButton" @click="cancel">Cancel</f7-link>
    </f7-toolbar>

      <div class="page-content">
  <!--
        <div class="navbar">
          <div class="navbar-inner">
            <div class="center">My Contacts</div>
          </div>
        </div>
-->
          <div class="contactDebtorListButtonContainer">
            <f7-grid no-gutter>
              <f7-col width="50" class="pilotageTabController">
                <f7-link class='pilotageLink' v-bind:class="{tabActive: currentRole === 'simple'}" tab-link=".requestContactTab1" @click="changeCurrentRole('simple')" active>Contact List</f7-link>
              </f7-col>
              <f7-col width="50" class="pilotageTabController">
                <f7-link class='pilotageLink' v-bind:class="{tabActive: currentRole === 'group'}" tab-link=".requestContactTab2" @click="changeCurrentRole('group')">Group List</f7-link>
              </f7-col>
            </f7-grid>
          </div>

        <f7-tabs>
            <f7-searchbar class=""
              cancel-link="Cancel"
              search-list="#remind-settings-contacts-list"
              placeholder="Search in Contacts">
            </f7-searchbar>
            <div class="container-fluid">
              <f7-tab class="requestContactTab1" active>
                <f7-list id="remind-settings-contacts-list" contacts>
                  <f7-list-group v-for="(group, key) in this.contacts" :key="key">
                    <f7-list-item :title="key" group-title></f7-list-item>
                    <li v-for="contact in group" v-on:change="changeItem()">
                      <label class="label-checkbox item-content">
                        <input class="inputContact" type="checkbox" name="remindSettingsContactsCheckbox" :value="contact.id" v-model="contactsSelected">
                        <div class="item-media">
                          <i class="icon icon-form-checkbox"></i>
                        </div>
                        <div class="item-inner">
                          <div class="item-title">{{contact.label}}</div>
                        </div>
                      </label>
                    </li>
                  </f7-list-group>
                </f7-list>

              </f7-tab>
          <f7-tab class="requestContactTab2">
            <f7-searchbar class=""
              cancel-link="Cancel"
              search-list="#remind-settings-contact-groups-list"
              placeholder="Search in Groups">
            </f7-searchbar>

            <f7-list id="remind-settings-contact-groups-list">
              <li v-for="(contactGroup, index) in contactGroups" v-on:change="changeGroupItem()">
                <label class="label-checkbox item-content">
                  <input type="checkbox" name="remindSettingsContactGroupsCheckbox" :value="contactGroup.id" v-model="contactGroupsSelected">
                  <div class="item-media">
                    <i class="icon icon-form-checkbox"></i>
                  </div>
                  <div class="item-inner">
                    <div class="item-title">{{ contactGroup.label }}</div>
                  </div>
                </label>
              </li>
            </f7-list>
          </f7-tab>
        </div>
        </f7-tabs>
        <div class="layoutBottomContactList"></div>

      </div>
  </div>
</template>

<script>
import pageNavBar from '@/components/common/pageNavBar.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'

export default {
  props: ['contactListType'],
  components: {
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar
  },
  data: () => {
    return {
      currentRole: '',
      contacts: [],
      contactsSelected: [],
      contactGroups: [],
      contactGroupsSelected: [],
      contactGroupsSelectedOld: []
    }
  },
  mounted () {
    let that = this
    this.currentRole = 'simple'

    var contactList = {}
    for (var j = 0; j < this.$engine.contacts.get().length; j++) {
      var firstLetter = this.$engine.contacts.get(j).label.substr(0, 1).toUpperCase()
      if (!contactList.hasOwnProperty(firstLetter)) {
        contactList[firstLetter] = []
      }
      contactList[firstLetter].push({label: this.$engine.contacts.get(j).label, iban: this.$engine.contacts.get(j).iban, login: this.$engine.contacts.get(j).login, name: this.$engine.contacts.get(j).name, id: this.$engine.contacts.get(j).id})
      contactList[firstLetter].sort()
    }
    this.contacts = this.orderKeys(contactList)
    that.contactGroups = this.$engine.contacts.getContactGroup()

    if (this.contactListType === 'add') {
      that.contactsSelected = this.$engine.settings.remindSettings.addRemindSettingContactsSelected
      that.contactGroupsSelected = this.$engine.settings.remindSettings.addRemindSettingContactGroupsSelected
      that.contactGroupsSelectedOld = this.$engine.settings.remindSettings.addRemindSettingContactGroupsSelected
    } else if (this.contactListType === 'edit') {
      that.contactsSelected = this.$engine.settings.remindSettings.editRemindSettingContactsSelected
      that.contactGroupsSelected = this.$engine.settings.remindSettings.editRemindSettingContactGroupsSelected
      that.contactGroupsSelectedOld = this.$engine.settings.remindSettings.editRemindSettingContactGroupsSelected
    }
  },
  methods: {
    orderKeys: function (obj, expected) {
      var keys = Object.keys(obj).sort(function keyOrder (k1, k2) {
        if (k1 < k2) return -1
        else if (k1 > k2) return +1
        else return 0
      })

      var i
      var after = {}
      for (i = 0; i < keys.length; i++) {
        after[keys[i]] = obj[keys[i]]
        delete obj[keys[i]]
      }

      for (i = 0; i < keys.length; i++) {
        obj[keys[i]] = after[keys[i]]
      }
      return obj
    },
    changeCurrentRole (role) {
      if (this.currentRole !== role) {
        this.currentRole = role
      }
      if (this.currentRole === 'simple') {
        this.Dom7('.requestContactTab2').removeClass('active')
        this.Dom7('.requestContactTab1').addClass('active')
      } else if (this.currentRole === 'group') {
        this.Dom7('.requestContactTab1').removeClass('active')
        this.Dom7('.requestContactTab2').addClass('active')
      }
    },
    changeItem () {
      let that = this
      that.contactsSelected = []
      this.Dom7('input[name=remindSettingsContactsCheckbox]:checked').each(function () {
        that.contactsSelected.push(that.Dom7(this).val())
      })
    },
    changeGroupItem () {
      let that = this
      that.contactGroupsSelected = []
      this.Dom7('input[name=remindSettingsContactGroupsCheckbox]:checked').each(function () {
        that.contactGroupsSelected.push(that.Dom7(this).val())
      })

      // Get unchecked contact group
      let contactGroupUnchecked = []
      for (let k = 0; k < that.contactGroupsSelectedOld.length; k++) {
        if (!that.contactGroupsSelected.includes(that.contactGroupsSelectedOld[k])) {
          contactGroupUnchecked.push(that.contactGroupsSelectedOld[k])
        }
      }

      // Delete contact from debtor list if contact is in un checked contact group
      for (let l = 0; l < that.contactGroups.length; l++) {
        if (contactGroupUnchecked.includes(that.contactGroups[l].id)) {
          for (let m = 0; m < that.contactGroups[l].contacts.length; m++) {
            var index = that.contactsSelected.indexOf(that.contactGroups[l].contacts[m])
            if (index > -1) {
              that.contactsSelected.splice(index, 1)
            }
          }
        }
      }
      // Add new contacts
      for (let i = 0; i < that.contactGroups.length; i++) {
        if (that.contactGroupsSelected.includes(that.contactGroups[i].id)) {
          for (let j = 0; j < that.contactGroups[i].contacts.length; j++) {
            if (!that.contactsSelected.includes(that.contactGroups[i].contacts[j])) {
              that.contactsSelected.push(that.contactGroups[i].contacts[j])
            }
          }
        }
      }
      that.contactGroupsSelectedOld = that.contactGroupsSelected
    },
    goBack () {
      let that = this
      if (this.contactListType === 'add') {
        this.$bus.emit('refresh-add-remind-setting-contacts', this.contactsSelected, this.contactGroupsSelected)
        this.$engine.settings.remindSettings.addRemindSettingContactsSelected = that.contactsSelected
        this.$engine.settings.remindSettings.addRemindSettingContactGroupsSelected = that.contactGroupsSelected
      } else if (this.contactListType === 'edit') {
        this.$bus.emit('refresh-edit-remind-setting-contacts', this.contactsSelected, this.contactGroupsSelected)
        this.$engine.settings.remindSettings.editRemindSettingContactsSelected = that.contactsSelected
        this.$engine.settings.remindSettings.editRemindSettingContactGroupsSelected = that.contactGroupsSelected
      }
      this.$f7.mainView.router.back()
    },
    cancel () {
      // let that = this
      // if (this.contactListType === 'add') {
      //   this.$bus.emit('refresh-add-remind-setting-contacts', this.contactsSelected, this.contactGroupsSelected)
      //   this.$engine.settings.remindSettings.addRemindSettingContactsSelected = that.contactsSelected
      //   this.$engine.settings.remindSettings.addRemindSettingContactGroupsSelected = that.contactGroupsSelected
      // } else if (this.contactListType === 'edit') {
      //   this.$bus.emit('refresh-edit-remind-setting-contacts', this.contactsSelected, this.contactGroupsSelected)
      //   this.$engine.settings.remindSettings.editRemindSettingContactsSelected = that.contactsSelected
      //   this.$engine.settings.remindSettings.editRemindSettingContactGroupsSelected = that.contactGroupsSelected
      // }
      this.$f7.mainView.router.back()
    }
  }
}
</script>

<style>
@media (min-width: 993px){
  .contactDebtorListButtonContainer {
    margin-top: 4%;
    margin-left: 260px;
    margin-right: auto;
    width: auto;
  }

  .searchbar {
    /*margin-left: 260px;
    margin-right: auto;*/
    width: auto;
  }
}
@media (max-width: 992px){
  .contactDebtorListButtonContainer {
    margin-top: 4%;
    margin-left: 0%;
    margin-right: 0%;
  }
  .searchbar {
    margin-left: 0%;
    margin-right: 0%;
  }
}
</style>
